export default "__VITE_ASSET__8c4d39e7__"